import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-lil flex flex-col align-items-center" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "text-4xl secondary-font text-grey-800 my-8" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _cache[1] || (_cache[1] = _createStaticVNode("<h1 class=\"secondary-font text-5xl text-center mt-5 mb-7\" data-v-5ce1c18a> Discuter avec <br data-v-5ce1c18a>un conseiller client </h1><div class=\"flex-center\" data-v-5ce1c18a><img src=\"/public/assets/tchat/600w/avatar.jpg\" class=\"size-3xl rounded-100 mx-2 my-2\" alt=\"Conseiller client\" data-v-5ce1c18a><img src=\"/public/assets/tchat/600w/avatar2.jpg\" class=\"size-3xl rounded-100 mx-2 my-2\" alt=\"Conseiller client\" data-v-5ce1c18a><img src=\"/public/assets/tchat/600w/avatar3.jpg\" class=\"size-3xl rounded-100 mx-2 my-2\" alt=\"Conseiller client\" data-v-5ce1c18a></div><div class=\"flex-center\" data-v-5ce1c18a><img src=\"/public/assets/tchat/600w/avatar4.jpg\" class=\"size-3xl rounded-100 mx-2 my-2\" alt=\"Conseiller client\" data-v-5ce1c18a><img src=\"/public/assets/tchat/600w/avatar5.jpg\" class=\"size-3xl rounded-100 mx-2 my-2\" alt=\"Conseiller client\" data-v-5ce1c18a><img src=\"/public/assets/tchat/600w/avatar6.jpg\" class=\"size-3xl rounded-100 mx-2 my-2\" alt=\"Conseiller client\" data-v-5ce1c18a></div>", 3)),
      _createElementVNode("a", {
        href: `tel:${_ctx.phoneNumberClean}`
      }, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.phoneNumber), 1)
      ], 8, _hoisted_2),
      _createElementVNode("a", {
        href: `tel:${_ctx.phoneNumberClean}`
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("button", { class: "btn lg btn-chatbot flex-center px-10 gap-2" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-aide-appel.svg",
            class: "btn-icon",
            alt: ""
          }),
          _createElementVNode("span", null, "Appelez maintenant")
        ], -1)
      ]))], 8, _hoisted_4),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "clear-both h-70" }, null, -1))
    ])
  ]))
}